import { render } from "./AdyenOrderPaymentOptions.vue?vue&type=template&id=5ab5058e"
import script from "./AdyenOrderPaymentOptions.vue?vue&type=script&lang=js"
export * from "./AdyenOrderPaymentOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__